export const EMAIL_TEMPLATE_COLUMN = [
  {
    Header: "Subject",
    Footer: "Subject",
    accessor: "Subject",
    sticky: "left",
  },
  {
    Header: "From Name",
    Footer: "From Name",
    accessor: "fromName",
  },
  {
    Header: "From Email",
    Footer: "From Email",
    accessor: "fromEmail",
  },
  {
    Header: "Email Type",
    Footer: "Email Type",
    accessor: "EmailType",
  },
  {
    Header: "Body",
    Footer: "Body",
    accessor: "body",
  },
  {
    Header: "Status",
    Footer: "Status",
    accessor: "status",
  },
  {
    Header: "Delete",
    Footer: "Delete",
    accessor: "delete",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "edit",
  },
];
